<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>

    <!-- FORM HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- FORM TITLE -->
                <div class="col-12 col-lg-5">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-person-lock me-2 fs-1 text-primary"></i>Rol
                    </h4>
                </div>

                <!-- FUNCTIONS BUTTONS -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                    <div *ngIf="opE === '1'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-pencil-square me-2"></i>Editar
                         </button>
                    </div>

                    <div *ngIf="opE === '1'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                            <i class="bi-trash3 me-2"></i>Eliminar
                        </button>
                    </div>

                    <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-save me-2"></i>Guardar
                        </button>
                    </div>

                    <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <!-- FORM CONTENT -->
    <div class="container pe-6">
        <div class="card card-body INN-form justify-content-center mt-2">
            <form class="needs-validation" novalidate>
                <div class="row g-3">

                    <!-- FIELD -->
                    <div class="col-md-12">
                        <label for="Field" class="form-label">Rol</label>
                        <input class="form-control" type="text" name="nombre" id="nombre" [(ngModel)]="rol.nombre" #nombre="ngModel" [ngClass]="{'is-invalid': nombre.invalid && (nombre.dirty || nombre.touched)}" (ngModelChange)="mostrarMensaje(nombre, 'nombre')" (blur)="mostrarMensaje(nombre, 'nombre')"
                            required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageNombre">
                            {{mensajeValidacionNombre}}
                        </p>
                    </div>

                </div>
            </form>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-2">
            <div class="row">

                <!-- FORM FOOTER CONTENT -->

            </div>
        </div>
    </div>


</div>
<!-- END MAIN CONTAINER -->